export default __webpack_public_path__ + "static/media/royal.c37c46bb.webp";